import script from "./Version.vue?vue&type=script&setup=true&lang=js"
export * from "./Version.vue?vue&type=script&setup=true&lang=js"

import "./Version.vue?vue&type=style&index=0&id=4ccd26b0&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ccd26b0"]])

export default __exports__